import { h } from 'preact';
import { useState, useEffect, useCallback } from 'preact/hooks';
import IconLeftSmall from "utils/icon/icon-left-small.svg";
import IconCloseSmall from "utils/icon/icon-close-small.svg";
import IconCaratRight from "utils/icon/icon-carat-right.svg";
import IconPlus from "utils/icon/icon-plus.svg";
import IconMinus from "utils/icon/icon-minus.svg";
import HeaderSecondaryNav from "./header-secondary-nav";

const MenuList = ({
  links, onBack, linksData, sunScreen, openSubMenu, animation = 'slide'
}) => {
  const [subMenu, setSubMenu] = useState(null);
  const isFadeAnimation = animation === 'fade';

  const handleClick = useCallback((item) => {
    if (item.id === subMenu?.id) {
      setSubMenu(null);
    } else {
      setSubMenu({ ...item })
      openSubMenu({ ...item })
    }
  }, [subMenu]);

  useEffect(() => {
    const handleCloseEvent = (e) => {
      if (!e.detail.open) {
        setTimeout(() => {
          setSubMenu(null);
          onBack();
        }, isFadeAnimation ? 500 : 0); // wait until fade animation ended
      }
    }
    document.addEventListener(`nav:toggle`, handleCloseEvent);
    return () => {
      document.removeEventListener(`nav:toggle`, handleCloseEvent);
    }
  }, []);

  return (
    <div className="absolute top-0 w-full h-full bg-white z-10 lg:static overflow-y-auto">
      <div className="h-16 flex items-center justify-between border-b lg:hidden">
        <button
          className="pl-2.5"
          type="button"
          tabIndex="0"
          onClick={onBack}
        >
          <div className="text-white hover:text-supergoop-yellow">
            <IconLeftSmall />
          </div>
        </button>
        <button
          className="pr-2"
          type="button"
          tabIndex="0"
          onClick={() => {
            document.dispatchEvent(new CustomEvent('nav:close'))
            document.body.style.overflow = '';
          }}
        >
          <div className="text-white hover:text-supergoop-yellow">
            <IconCloseSmall />
          </div>
        </button>
      </div>

      <ul className="lg:px-10 lg:pb-10">
        {links.map((item) => (
          <li key={item.id} className="border-b lg:border-0 lg:mb-7 last:mb-0">
            {!!item.links?.length && (
              <button type="button" onClick={() => handleClick(item)} tabIndex="0" className="py-4 lg:py-0 pl-5 lg:pl-0 pr-2.5 lg:pr-0 flex lg:!inline-block w-full items-center justify-between no-underline cursor-pointer lg:cursor-default lg:text-left lg:w-auto">
                <div className={`${subMenu?.id === item.id && 'lg:text-supergoop-blue'} sub-h4 text-grey-2A lg:link-list lg:!sub-h3 lg:inline-block cursor-pointer`}>
                  {item.title}
                </div>
                <div className="text-white lg:hidden">
                  {subMenu?.id === item.id ? <IconMinus /> : <IconPlus />}
                </div>
              </button>
            )}
            {!item.links?.length && (
              <a href={item.url} className="py-4 lg:py-0 pl-5 lg:pl-0 pr-2.5 lg:pr-0 flex lg:inline-block w-full items-center justify-between no-underline lg:text-left lg:cursor-default ">
                <div className="sub-h4 text-grey-2A lg:link-list lg:!sub-h3 lg:cursor-pointer lg:inline-block">{item.title}</div>
                <div className="text-white lg:hidden">
                  <IconCaratRight />
                </div>
              </a>
            )}
            {!!subMenu && subMenu.id === item.id && (
              <HeaderSecondaryNav menu={subMenu} linksData={linksData} />
            )}
          </li>
        ))}
      </ul>
      <div className="block lg:hidden mt-5">
        {sunScreen}
      </div>
    </div>
  )
};

export default MenuList;
